/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedFollowsByActor.defs.js'
export * as $defs from './getSuggestedFollowsByActor.defs.js'
